/** Billing (mocked provider): snapshot, previews, changes, trial, invoices, portal. */
import type { EndpointDef } from '../endpointTypes'

export const billingRoutes = {
  billing: { method: 'GET', path: '/api/me/billing', note: 'BillingSnapshot' },
  billingPreview: { method: 'POST', path: '/api/me/billing/preview', note: 'Quote for a plan/addon change' },
  billingChange: { method: 'POST', path: '/api/me/billing/change', note: 'Apply a quoted change' },
  billingKeep: { method: 'POST', path: '/api/me/billing/keep', note: 'Keep the current plan (cancel a scheduled change)' },
  billingTrial: { method: 'POST', path: '/api/me/billing/trial', note: 'action: start | cancel | resume' },
  billingPortal: { method: 'POST', path: '/api/me/billing/portal', note: 'Mock payment-method portal; returns { provider, url }' },
  billingInvoice: { method: 'GET', path: '/api/me/billing/invoices/:invoiceId' },
} as const satisfies Record<string, EndpointDef>
